import React from "react";

/**
 * Five tappable stars (1–5). `value` is the current rating or null.
 * Read-only when `onChange` is absent (used on the confirmation screen).
 */
const StarRating = ({ value, onChange, name, size = 32 }) => {
  const readOnly = typeof onChange !== "function";
  return (
    <div
      className={`fb_stars${readOnly ? " fb_stars_readonly" : ""}`}
      role={readOnly ? "img" : "radiogroup"}
      aria-label={readOnly ? `${value || 0} out of 5` : name}
    >
      {[1, 2, 3, 4, 5].map((n) => {
        const filled = typeof value === "number" && n <= value;
        return (
          <button
            key={n}
            type="button"
            className={`fb_star${filled ? " fb_star_filled" : ""}`}
            style={{ width: size, height: size }}
            role={readOnly ? undefined : "radio"}
            aria-checked={readOnly ? undefined : value === n}
            aria-label={`${n} star${n > 1 ? "s" : ""}`}
            disabled={readOnly}
            onClick={() => onChange && onChange(n)}
          >
            <svg viewBox="0 0 24 24" width={size * 0.8} height={size * 0.8}>
              <path
                d="M12 2.5l2.9 6.2 6.8.8-5 4.7 1.3 6.8L12 17.7 5.9 21l1.3-6.8-5-4.7 6.8-.8L12 2.5z"
                fill={filled ? "#f5a623" : "none"}
                stroke={filled ? "#f5a623" : "#b0b0b0"}
                strokeWidth="1.5"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        );
      })}
    </div>
  );
};

export default StarRating;
